import React from 'react';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Performance from '@/components/Performance';
import CaseStudy from '@/components/CaseStudy';
import About from '@/components/About';
import Contact from '@/components/Contact';

const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <Performance />
      <CaseStudy />
      <About />
      <Contact />
    </main>
  );
};

export default Home;
